import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PUT_EXAM_FEE_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PutExamFeeRequest {
  examFeeUuid: string;

  gstPercent: number;
  gstInclusive: boolean;
  registrationFee: number;
  lateRegistrationFee: number;

  // Field for AEIS Exam
  admissionLevelCodes?: string[];

  // Field for SPERS Exam
  firstTimerRegistrationFee?: number;
  secondTimerRegistrationFee?: number;
  firstTimerLateFee?: number;
  secondTimerLateFee?: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutExamFee = ({ onSuccess, onError }: Input) => {
  const putExamFee = async (payload: PutExamFeeRequest) => {
    const res = await axiosClient.put<void>(PUT_EXAM_FEE_URL(payload.examFeeUuid), payload);
    return res.data;
  };

  return useCustomMutation(putExamFee, {
    onSuccess,
    onError,
  });
};
